import React from 'react';
import { CheckIcon, PlusIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

/**
 * Wybór „czego potrzebujesz” jako karty ze zdjęciami produktów, jak w
 * konfiguratorze samochodu: moduły, falownik i magazyn, każdy zaznaczany osobno.
 *
 * ═══ HISTORIA ═══
 * Najpierw trzy przyciski wariantów („bez magazynu / z magazynem / zastanawiam
 * się”), potem rysunek domu do klikania, odrzucony przez właściciela jako
 * wyglądający „jak z Painta” (2026-09-30). Karty zostały wybrane spośród
 * czterech wariantów jako najbardziej praktyczne: zdjęcie mówi, co to za
 * urządzenie, także komuś, kto nie wie, co to falownik.
 *
 * Zdjęcia to NASZE rendery bez marki (public/thumbnail_*.png, te same co przy
 * ofertach bez zdjęcia), wycięte do samego produktu i zapisane w public/dobor/.
 * Własne pliki, a nie zdjęcia ze sklepów: w najważniejszym miejscu strony nie
 * może zniknąć obrazek, bo sklep zmienił adres, ani stać logo jednego producenta.
 *
 * Pliki mają przezroczyste tło (od 2026-10-01), więc zdjęcie stoi na kolorze
 * karty, a nie w białym prostokącie.
 *
 * Kolor niesie znacznik w rogu: pełne niebieskie kółko z fajką przy wybranym,
 * puste z plusem przy niewybranym, a zdjęcie niewybranego blednie.
 *
 * Nazwy kart w słowniku `glowna` (hero.wybor.<key>).
 */
const PRODUKTY = [
  { key: 'panels', zdjecie: '/dobor/modul.webp' },
  { key: 'inverter', zdjecie: '/dobor/falownik.webp' },
  { key: 'battery', zdjecie: '/dobor/magazyn.webp' },
];

const WyborProduktow = ({ wybrane, onPrzelacz }) => {
  const { t } = useTranslation('glowna');
  return (
  <div className="grid grid-cols-3 gap-2" role="group" aria-label={t('hero.wybor.aria')}>
    {PRODUKTY.map(({ key, zdjecie }) => {
      const wlaczony = Boolean(wybrane[key]);
      return (
        <button
          key={key}
          type="button"
          aria-pressed={wlaczony}
          onClick={() => onPrzelacz(key)}
          className={`group/karta relative flex flex-col items-stretch rounded-xl border p-1 text-center
                      transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 ${
            wlaczony
              ? 'border-blue-500 ring-1 ring-blue-500 bg-blue-50/60'
              : 'border-gray-200 bg-white hover:border-blue-300'
          }`}
        >
          {/* Stała wysokość, a nie kwadrat: kwadrat rósł z szerokością ekranu
              i na szerokich monitorach wypychał kroki 1 do 4 pod ekran.
              `h-16` zamiast `h-12` (2026-10-01): po zmniejszeniu kafelka zdjęcia
              były najmniej czytelne, więc dostały miejsce z odstępów wokół. */}
          <span className="block h-16 w-full overflow-hidden rounded-lg">
            {/* Bez `loading="lazy"`: karty stoją na górze strony, a leniwe
                ładowanie tylko opóźniało obrazek (pliki mają po 2 do 5 KB). */}
            <img
              src={`${process.env.PUBLIC_URL}${zdjecie}`}
              alt=""
              className={`h-full w-full object-contain p-0.5 transition-all duration-200 ${
                wlaczony ? '' : 'opacity-50 grayscale group-hover/karta:opacity-75'
              }`}
            />
          </span>
          <span className={`mt-1 mb-0.5 block text-[11px] font-semibold leading-tight ${
            wlaczony ? 'text-blue-800' : 'text-gray-500'
          }`}>
            {t(`hero.wybor.${key}`)}
          </span>
          <span className={`absolute top-2 right-2 flex items-center justify-center w-5 h-5 rounded-full
                            shadow-sm transition-colors ${
            wlaczony ? 'bg-blue-600 text-white' : 'bg-[#ffffff] border border-gray-300 text-gray-400'
          }`}>
            {wlaczony
              ? <CheckIcon className="w-3.5 h-3.5" strokeWidth={3} />
              : <PlusIcon className="w-3.5 h-3.5" strokeWidth={3} />}
          </span>
        </button>
      );
    })}
  </div>
  );
};

export default WyborProduktow;
